import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddNewCountry, getCountryList, getHotelList, UpdateCountryStatus, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";
import { useNavigate } from "react-router-dom";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";

const hotelfilterData = {
    iso2:null,
    iso3:null,
    phoneCode:null,
  }

const CountryList = () => {
    const [countryList,setCountryList] = useState([]); 
    const [hoteldata,setHotelData] =  useState({...hotelfilterData});
    const [totalPages, setTotalPages] = useState(null);
    const [totalElements, setTotalElements] = useState("");
    const [currPage, setCurrPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [showCountry,setCountry] = useState(false);
    const [newCountryData, setNewCountryData] = useState({
      countryName: null,
      iso2: null,
      iso3: null,
      phoneCode: null,
      active: null,
  });

  const [errors, setErrors] = useState({});
  const [loading,setLoading] = useState(false);
const navigate = useNavigate();

const validateForm = () => {
  const newErrors = {};
  if (!newCountryData.countryName) {
      newErrors.countryName = "Country Name is required";
  }
  if (!newCountryData.iso2) {
      newErrors.iso2 = "ISO2 Code is required";
  } else if (newCountryData.iso2.length !== 2) {
      newErrors.iso2 = "ISO2 Code must be 2 characters";
  }
  if (!newCountryData.iso3) {
      newErrors.iso3 = "ISO3 Code is required";
  } else if (newCountryData.iso3.length !== 3) {
      newErrors.iso3 = "ISO3 Code must be 3 characters";
  }
  if (!newCountryData.phoneCode) {
      newErrors.phoneCode = "Phone Code is required";
  } else if (!/^\d+$/.test(newCountryData.phoneCode)) {
      newErrors.phoneCode = "Phone Code must be numeric";
  }
  if (newCountryData.active === "") {
      newErrors.active = "Status is required";
  }
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

console.log("error",errors);



  
    const handleViewCity = (cityId) => {
      navigate(`/hotel/view/Country/${cityId}`); // Navigate to the city details page
    };

    const handleModalInputChange = (e) => {
      const { name, value } = e.target;
      setNewCountryData((prev) => ({
          ...prev,
          [name]: value,
      }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
  };

    const handleDetailData = (e) => {
        const { name, value } = e.target;
        setHotelData((prev) => ({
            ...prev,
            [name]: value ? value:null,
        }));

        
    };
   
    const showCountryList = (page, key="")=>{
        setCurrPage(page);
        console.log("setDetailData",hoteldata)
        let param = {
            page:page,
            iso2:hoteldata?.iso2,
            iso3:hoteldata?.iso3,
            phoneCode:hoteldata?.phoneCode,
           // active:hoteldata?.active
           
        }
        if(key === "refresh"){
        
        
       setHotelData({...hotelfilterData});
         param = hotelfilterData;
      }
        
        setLoading(true);
            getCountryList(param).then((resp)=>{
                setLoading(false)
                if(resp){
                    
                    setCountryList(resp?.data?.data?.country?.content);
                    setTotalPages(resp?.data?.data?.country?.totalPages)
                
                }
            
        
        
            })
        }
        const currPageSet = (currentPage) =>{
        
            showCountryList(currentPage)
        
        }

        useEffect(()=>{
            showCountryList(currPage);
            },[])
            
            const handleAddCountry =()=>{
              setCountry((prev)=>prev ? false :true);
            }
        
            const handleSubmit = () => {
              if (validateForm()) {
                  AddNewCountry(newCountryData).then((resp) => {
                      if (resp?.success) {
                          showCountryList(0); // Refresh the list
                          setCountry(false); // Close the modal
                      }
                  });
              }
          };

          const updateStatus =(id)=>{

       
          UpdateCountryStatus(id).then((res)=>{
              if(res){
                showCountryList(currPage);
              }

            })

          }



    return(
        <>
         <div className="userlisthead_container">
         <div style={{ padding: "30px" }}>
         <div className="transaction_main_container">
         <div className="userlist_head mb-5">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>Country List</label>
              </div>
              <div>
            <button onClick={() => navigate("/hotel/addCountry")} className="userlist_btn">Add New Country</button>
            
           </div>
             
            </div>
          </div>          
               <FilterWrapper>
          <div className="filterBox">
              <div style={{width:"100%"}}>
                <div className="flex align-items gap-20">
                 
                  <div>
                    <input
                      type="text"
                      name="iso2"
                      placeholder="ISO2"
                      value={hoteldata?.iso2}
                      onChange={handleDetailData}
                    
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="iso3"
                      placeholder="ISO3"
                      value={hoteldata?.iso3}
                      onChange={handleDetailData}
                     
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="phoneCode"
                      placeholder="Phone Code"
                      value={hoteldata?.phoneCode}
                     onChange={handleDetailData}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div>

                 
                 
                  <div className="button">
                    <button
                      className="userlist_btn"
                      onClick={(e) => showCountryList(0,"search")}
                    >
                      Search
                    </button>
                  </div>

                  <div className="button">
                    <button
                      className="refresh-btn"
                      onClick={(e) => showCountryList(e, "refresh")}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

              </FilterWrapper>
          </div>

          <div className="table-loader">
            { loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                   <th>COUNTRY NAME</th>
                    <th>ISO2 CODE</th>
                    <th>ISO3 CODE</th>
                    <th>PHONE CODE</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                    
                   
                   
                  </tr>
                </thead>
                <tbody>

                    {countryList && countryList?.map((items)=>{
                      return (

                        <>
                         <tr>
                            <td>{items?.name}</td>
                            <td>{items?.iso2}</td>
                            <td>{items?.iso3}</td>
                            <td>{items?.phoneCode}</td>

                            <td>
                            <div
                                    className={`custom-toggle toggle_button ${
                                      items.active === true ? "active" : ""
                                    }`}
                                     onClick={() =>
                                       updateStatus(items.id, items.active)
                                   }
                                    styled={{
                                      margin: "0",
                                      marginRight: "12px",
                                    }}
                                  >
                                    <div className="slider"></div>
                                  </div>
                            </td>
                       
                            <td className="user_action_btn button">
                  <span>
                    <button onClick={() => handleViewCity(items?.id)}>
                    <i class="fa-solid fa-pen-to-square update" aria-hidden="true"></i>

                    </button>
                  </span>
                            </td>
                       
                         </tr>
                        
                        
                        </>
                      )


                    })}

                </tbody>
              </table>
            </TableWrapper>
          </div>
            
            
             
          {totalPages > 1 && (
        <Pagination
         items={showCountryList}
          itemsPerPage={pageSize}
          setitemsPerPage={setPageSize}
          currentPage={currPage}
          setcurrentPage={(page)=>currPageSet(page)}
          totalPages={totalPages}
          forcePage={currPage}
        />
      )}
            
            </div>
        
        
        
        
         </div>
    {showCountry && <ModalPopUp>
         <div className="subadmin_container justify-between flex column gap-20" style={{width:"50%"}}>
         <div style={{padding:"30px",flex:"1 1 100%"}}>
            <p>Add New Country</p>
       <div className="flex gap-10">

          <div style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Country Name</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Country Name"
                  name="countryName"
                value={newCountryData?.countryName}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.countryName && (
                  <p className="error fs-12 mt-10">{errors.countryName}</p>
                )}
              </div>

              <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname">
                  <label>Status</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                    value={newCountryData?.active}
                  onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
                    {errors.active && (
                  <p className="error fs-12 mt-10">{errors.active}</p>
                )}
                  </div>
                 
          </div>
        

          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Iso2</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Iso2"
                  name="iso2"
               value={newCountryData?.iso2}
                onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.iso2 && (
                  <p className="error fs-12 mt-10">{errors.iso2}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Iso3</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Iso3"
                  name="iso3"
                 value={newCountryData?.iso3}
                 onChange={handleModalInputChange}
                 
                 // click={checkStatus}
                />
                {errors.iso3 && (
                  <p className="error fs-12 mt-10">{errors.iso3}</p>
                )}
              </div>
          </div>

          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Phone Code</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Phone Code"
                  name="phoneCode"
                value={newCountryData?.phoneCode}
                  onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.phoneCode && (
                  <p className="error fs-12 mt-10">{errors.phoneCode}</p>
                )}
              </div>

             
          </div>

         </div>
       
         <div className="flex gap-10" style={{padding:"30px"}}>
        
         <div>
          <button onClick={handleAddCountry} className="userlist_btn">Cancle</button>
        </div>
        <div>
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         </div>
         </div>

         </ModalPopUp>}
        
        
        </>
    )

}

export default CountryList;